import { lazy, Suspense } from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'

import { useCurrentUser } from './api/auth/queries/useCurrentUser'
import { Spinner } from './Components/ui/spinner'
import ScrollToTop from './helpers/ScrollToTop'
// New screens (v2) - loaded regularly
import ClientPage from './PageComponents/v2/ClientPage'
import ClientPkgPage from './PageComponents/v2/ClientPkg/ClientPkgsPage'
import ForgotPasswordPage from './PageComponents/v2/Login/ForgotPasswordPage'
import LoginPage from './PageComponents/v2/Login/LoginPage'
import MyAddressesPage from './PageComponents/v2/MyAddresses/MyAddresses'
import PaymentPage from './PageComponents/v2/Payment/PaymentPage'
import ProfilePage from './PageComponents/v2/Profile/ProfilePage'
import ReceiptUploadPageV2 from './PageComponents/v2/ReceiptUpload/ReceiptUploadPage'
import ReturnPkgPage from './PageComponents/v2/ReturnPkg/ReturnPkgPage'
import UnitePkgPage from './PageComponents/v2/UnitePkg/UnitePkgPage'
import { RoutePath } from './RoutePath'

// Old screens - loaded lazily
// const MyPackagesScreenPage = lazy(() => import('./PageComponents/ClientSide/MyPackagesScreen/MyPackagesScreenPage'))
// const PackageDetailsPage = lazy(() => import('./PageComponents/ClientSide/PackageDetailsPage/PackageDetailsPage'))
// const Payment = lazy(() => import('./PageComponents/ClientSide/Payment/Payment'))
// const PaymentSuccessful = lazy(() => import('./PageComponents/ClientSide/PaymentSuccessful/PaymentSuccessful'))
// const PaymentSuccessfulRP = lazy(() => import('./PageComponents/ClientSide/PaymentSuccessfulRP/PaymentSuccessfulRP'))
// const ReceiptUploadPage = lazy(() => import('./PageComponents/ClientSide/ReceiptUploadPage/ReceiptUploadPage'))
// const ReturnLabelUploadPage = lazy(() => import('./PageComponents/ClientSide/ReturnLabelUploadPage/ReturnLabelUploadPage'))
// const ReturnPackagePage = lazy(() => import('./PageComponents/ClientSide/ReturnPackagePage/ReturnPackagePage'))
// const SignInComponent = lazy(() => import('./PageComponents/ClientSide/SignInComponent'))
const AddNewPackagePage = lazy(() => import('./PageComponents/OfficeSide/AddNewPackage/AddNewPackagePage'))
const AffiliatePage = lazy(() => import('./PageComponents/OfficeSide/Affiliate/AffiliatePage'))
const AllPackagesPage = lazy(() => import('./PageComponents/OfficeSide/AllPackagesPage/AllPackagesPage.jsx'))
const BarcodeGunShip = lazy(() => import('./PageComponents/OfficeSide/BarcodeGunShip/BarcodeGunShip'))
const CouponOfficePage = lazy(() => import('./PageComponents/OfficeSide/Coupon/CouponOfficePage'))
const DelayedPayments = lazy(() => import('./PageComponents/OfficeSide/DelayedPayments/DelayedPayments'))
const EditAndUpdatePage = lazy(() => import('./PageComponents/OfficeSide/EditAndUpdate/EditAndUpdatePage'))
const Location = lazy(() => import('./PageComponents/OfficeSide/Location/Location'))
const CheckForm = lazy(() => import('./PageComponents/OfficeSide/PackageChecklist/checkForm'))
const PackageRequests = lazy(() => import('./PageComponents/OfficeSide/PackageRequests/PackageRequests'))
const PrintPackage = lazy(() => import('./PageComponents/OfficeSide/Print/printPackage'))
const ReceiveShipments = lazy(() => import('./PageComponents/OfficeSide/RecieveShipments/ReceiveShipments'))
const OfficeShipPageComponent = lazy(() => import('./PageComponents/OfficeSide/Ship/OfficeShipPageComponent'))
const Stats = lazy(() => import('./PageComponents/OfficeSide/Stats/Stats'))
const Sticker = lazy(() => import('./PageComponents/OfficeSide/Sticker/Sticker'))
const WarehouseArrivalsPage = lazy(() => import('./PageComponents/OfficeSide/WarehouseArrivals/WarehouseArrivalsPage'))

const RouteWrapper = ({ Component, ...props }) => {
  return (
    <Suspense
      fallback={
        <div className='flex items-center justify-center' style={{ height: '100vh' }}>
          <Spinner className='size-12' />
        </div>
      }
    >
      <Component {...props} />
    </Suspense>
  )
}

const ProtectedRoute = ({ children, ...props }) => {
  const { data: loggedUser } = useCurrentUser()
  return <Route {...props}>{loggedUser?.Username ? children : <LoginPage />}</Route>
}

export default function Layout() {
  const { data: loggedUser } = useCurrentUser()

  return (
    <div className='layOutDiv'>
      <ScrollToTop />

      <Switch id='shiptanbul-switch'>
        <Route path='/welcome'>
          <LoginPage />
        </Route>

        <Route path={RoutePath.Login}>
          <LoginPage />
        </Route>

        <Route path={RoutePath.ForgotPassword}>
          <ForgotPasswordPage />
        </Route>

        <ProtectedRoute v2 path={RoutePath.Client}>
          <ClientPage>
            <Route exact path={RoutePath.ClientProfile}>
              <ProfilePage />
            </Route>
            <Route exact path={RoutePath.ClientProfilePersonal}>
              <ProfilePage />
            </Route>
            <Route exact path={RoutePath.ClientProfileAddresses}>
              <ProfilePage />
            </Route>
            <Route exact path={RoutePath.ClientProfileAffiliate}>
              <ProfilePage />
            </Route>
            <Route exact path={RoutePath.ClientAddresses}>
              <MyAddressesPage />
            </Route>
            <Route path={`${RoutePath.ClientPkgReturn}/:pkgId`}>
              <ReturnPkgPage />
            </Route>
            <Route exact path={RoutePath.ClientPkg}>
              <ClientPkgPage />
            </Route>
            <Route exact path={RoutePath.ClientPkgUnite}>
              <UnitePkgPage />
            </Route>
          </ClientPage>
        </ProtectedRoute>

        <ProtectedRoute v2 path={`${RoutePath.ReceiptUpload}/:pkgId`}>
          <ReceiptUploadPageV2 />
        </ProtectedRoute>

        <ProtectedRoute v2 path={`${RoutePath.PaymentShipping}/:pkgId`}>
          <PaymentPage />
        </ProtectedRoute>

        <ProtectedRoute v2 path={`${RoutePath.PaymentSummary}/:pkgId`}>
          <PaymentPage />
        </ProtectedRoute>

        <ProtectedRoute v2 path={`${RoutePath.PaymentProcess}/:pkgId`}>
          <PaymentPage />
        </ProtectedRoute>

        {/* <ProtectedRoute path='/old/personal-info'>
          <RouteWrapper Component={MyPackagesScreenPage} />
        </ProtectedRoute>

        <ProtectedRoute path='/old/receipt-upload'>
          <RouteWrapper Component={ReceiptUploadPage} />
        </ProtectedRoute>

        <ProtectedRoute path='/old/package-details'>
          <RouteWrapper Component={PackageDetailsPage} />
        </ProtectedRoute>

        <ProtectedRoute path='/old/package-return-label'>
          <RouteWrapper Component={ReturnLabelUploadPage} />
        </ProtectedRoute>

        <ProtectedRoute path='/old/payment'>
          <RouteWrapper Component={Payment} />
        </ProtectedRoute>

        <ProtectedRoute path='/old/payment-successful:cfields?'>
          <RouteWrapper Component={PaymentSuccessful} />
        </ProtectedRoute>

        <ProtectedRoute path='/old/rp-payment-successful'>
          <RouteWrapper Component={PaymentSuccessfulRP} />
        </ProtectedRoute>

        <ProtectedRoute path='/old/return-package'>
          <RouteWrapper Component={ReturnPackagePage} />
        </ProtectedRoute> */}

        <ProtectedRoute path='/office'>
          {loggedUser &&
            (loggedUser.permissions['Admin'] || loggedUser.permissions['Worker'] || loggedUser.permissions['OfficeManager']) && (
              <RouteWrapper Component={AddNewPackagePage} />
            )}
        </ProtectedRoute>

        <ProtectedRoute path='/office-ship'>
          {loggedUser &&
            (loggedUser.permissions['Admin'] || loggedUser.permissions['Worker'] || loggedUser.permissions['OfficeManager']) && (
              <RouteWrapper Component={OfficeShipPageComponent} />
            )}
        </ProtectedRoute>

        <ProtectedRoute path='/office-e&u'>
          {loggedUser &&
            (loggedUser.permissions['Admin'] ||
              loggedUser.permissions['Agent'] ||
              loggedUser.permissions['OfficeManager'] ||
              loggedUser.permissions['SeniorAgent'] ||
              loggedUser.permissions['Worker']) && <RouteWrapper Component={EditAndUpdatePage} />}
        </ProtectedRoute>

        <ProtectedRoute path='/office-packageRequests/:reqType?/:reqId?'>
          {loggedUser &&
            (loggedUser.permissions['Admin'] ||
              loggedUser.permissions['SeniorAgent'] ||
              loggedUser.permissions['Agent'] ||
              loggedUser.permissions['Worker'] ||
              loggedUser.permissions['OfficeManager']) && <RouteWrapper Component={PackageRequests} />}
        </ProtectedRoute>

        <ProtectedRoute path='/office-print'>
          {loggedUser &&
            (loggedUser.permissions['Admin'] ||
              loggedUser.permissions['Agent'] ||
              loggedUser.permissions['SeniorAgent'] ||
              loggedUser.permissions['Worker'] ||
              loggedUser.permissions['OfficeManager']) && <RouteWrapper Component={PrintPackage} />}
        </ProtectedRoute>

        <ProtectedRoute path='/office-checkForm'>
          {loggedUser &&
            (loggedUser.permissions['Admin'] || loggedUser.permissions['Worker'] || loggedUser.permissions['OfficeManager']) && (
              <RouteWrapper Component={CheckForm} />
            )}
        </ProtectedRoute>

        <ProtectedRoute path='/office-stats'>
          {loggedUser && (loggedUser.permissions['Admin'] || loggedUser.permissions['OfficeManager']) && <RouteWrapper Component={Stats} />}
        </ProtectedRoute>

        <ProtectedRoute path='/office-affiliate'>
          {loggedUser && loggedUser.permissions['Admin'] && <RouteWrapper Component={AffiliatePage} />}
        </ProtectedRoute>

        <ProtectedRoute path='/office-coupon'>
          {loggedUser && loggedUser.permissions['Admin'] && <RouteWrapper Component={CouponOfficePage} />}
        </ProtectedRoute>

        <ProtectedRoute path='/office-receive-shipments'>
          {loggedUser && (loggedUser.permissions['Admin'] || loggedUser.permissions['Worker']) && (
            <RouteWrapper Component={ReceiveShipments} />
          )}
        </ProtectedRoute>

        <ProtectedRoute path='/office-delayed-payments'>
          {loggedUser &&
            (loggedUser.permissions['Admin'] || loggedUser.permissions['Worker'] || loggedUser.permissions['OfficeManager']) && (
              <RouteWrapper Component={DelayedPayments} />
            )}
        </ProtectedRoute>

        <ProtectedRoute path='/all-packages-view'>
          {loggedUser &&
            (loggedUser.permissions['Admin'] || loggedUser.permissions['OfficeManager'] || loggedUser.permissions['Worker']) && (
              <RouteWrapper Component={AllPackagesPage} />
            )}
        </ProtectedRoute>

        <ProtectedRoute path='/office-ship-barcode-gun'>
          {loggedUser &&
            (loggedUser.permissions['Admin'] || loggedUser.permissions['OfficeManager'] || loggedUser.permissions['Worker']) && (
              <RouteWrapper Component={BarcodeGunShip} />
            )}
        </ProtectedRoute>

        <ProtectedRoute path='/office-location'>
          {loggedUser &&
            (loggedUser.permissions['Admin'] || loggedUser.permissions['OfficeManager'] || loggedUser.permissions['Worker']) && (
              <RouteWrapper Component={Location} />
            )}
        </ProtectedRoute>

        <ProtectedRoute path='/office-warehouse-arrivals'>
          {loggedUser && (loggedUser.permissions['Admin'] || loggedUser.permissions['OfficeManager']) && (
            <RouteWrapper Component={WarehouseArrivalsPage} />
          )}
        </ProtectedRoute>

        <ProtectedRoute path='/office-sticker/:pId/:name/:unit/:brand'>
          {loggedUser &&
            (loggedUser.permissions['Admin'] || loggedUser.permissions['OfficeManager'] || loggedUser.permissions['Worker']) && (
              <RouteWrapper Component={Sticker} />
            )}
        </ProtectedRoute>

        <Route exact path='/'>
          <LoginPage />
        </Route>
        {/*
        <Route exact path='/old'>
          <RouteWrapper Component={SignInComponent} />
        </Route> */}

        <Route path='/personal-info'>
          <Redirect to={RoutePath.ClientAddresses} />
        </Route>
        <Route path='/receipt-upload'>
          <Redirect to={RoutePath.ClientAddresses} />
        </Route>
        <Route path='/package-details'>
          <Redirect to={RoutePath.ClientAddresses} />
        </Route>
        <Route path='/package-return-label'>
          <Redirect to={RoutePath.ClientAddresses} />
        </Route>
        <Route path='/payment'>
          <Redirect to={RoutePath.ClientAddresses} />
        </Route>
        <Route path='/payment-successful'>
          <Redirect to={RoutePath.ClientAddresses} />
        </Route>
        <Route path='/rp-payment-successful'>
          <Redirect to={RoutePath.ClientAddresses} />
        </Route>
        <Route path='/return-package'>
          <Redirect to={RoutePath.ClientAddresses} />
        </Route>
      </Switch>
    </div>
  )
}
